import axios from 'axios';

const api = axios.create({ baseURL: process.env.REACT_APP_BACKEND_URL });

// cringe_backend/middleware reads "<sessionId>&<organizationId>" from the Bearer token.
const config = (s) => ({ headers: { Authorization: `Bearer ${s.sessionId}&${s.organizationId}` } });

const post = (path, s, extra = {}) => api.post(path, { ...s, ...extra }, config(s)).then((r) => r.data);

export const fetchCringeState = (s) => post('/cringe/state', s);
export const startCringe = (s) => post('/cringe/start', s);
export const submitCringe = (s, question, score, timer) => post('/cringe/submit', s, { question, score, timer });
export const linkCringeReport = (s, reportId) => post('/cringe/linkReport', s, { reportId });
